module.exports = __webpack_public_path__ + "assets/img/accountConnectionImg.77d26d5b.png";